import { useState } from 'react';
import { useUserStrategies } from '../../../context/UserStrategies';
import { StrategyBacktest } from '../StrategyBacktest';
import { PlaceholderStrategy } from '../../Strategies/Placeholder';
import { t } from 'i18next';

export type TCompareWidgetProps = {
  width: number;
};

export const StrategiesBacktest = ({ width }: TCompareWidgetProps) => {
  const { strategies } = useUserStrategies();
  const [footer, setFooter] = useState<JSX.Element | undefined>(<></>);

  return strategies.length < 2 ? (
    <PlaceholderStrategy
      title={t('placeholders.compareStrategies.title')}
      subtitle={t('placeholders.compareStrategies.subtitle')}
    />
  ) : (
    <StrategyBacktest standAlone width={width} setLegend={setFooter} />
  );
};
